import { wrapWc } from 'brinejs/wrapper'
import '@ica-azure/ica-elements/IcaHeader'

type IcaHeaderProps = React.JSX.IntrinsicElements['tgdb-ica-header']

export const IcaHeader = wrapWc<IcaHeaderProps & {
  onRightactionclick?: (e: { detail: { id: string } }) => void
  onLeftactionclick?: (e: CustomEvent) => void
}>('tgdb-ica-header', ['rightactionclick', 'leftactionclick'])
